// =============================================================================
// Bizportal.rs 16102026-5 -- InText_2..10 + PUBLICIS + DELETED BIDDERS OUT + HARDENING
// =============================================================================
// Base: 24102024/ads.js (live on 16.10.2026). Prebid lib unchanged (copy of
// 24102024/prebid.js). Ids from the Alo HB sheet, tab Bizportal.rs.
//
//   1. InText_2 .. InText_10: new slots, lazy loaded (template divs carry
//      lazyAd), same sizes as InText_1, bidders = the sheet's live columns.
//
//   2. Publicis Adform SSP ("Publicis Desktop" / "Publicis Mobile" columns)
//      on Adhesion (Sticky), Billboard, P1, P2, P3, InText_1 and InText_2.
//      Desktop or mobile placement is picked by screen width (publicisBid
//      below). Publicis goes out under its own alias "publicis" (Adform
//      adapter, gvlid 50): the adapter sends all placements of one bidder
//      code in one request, and Adform drops the whole request when an
//      account in it (Publicis = 3349) is not in ads.txt. As a separate
//      request it cannot take 'adform' down with it.
//
//   3. Bidders the sheet marks deleted are removed from every ad unit:
//      criteo, smn, appnexus (Xandr), yandex, and the commented-out
//      connectad lines ("ConnectAd - deleted" since 16.10.2026). Direct Media
//      stays (live column on the Bizportal.rs tab). The Criteo user-id module
//      stays: it is an id provider for every bidder, not a bidder.
//
//   4. GAM WITHOUT PREBID. The first GAM request was sent only from Prebid's
//      bidsBackHandler (and itself queued on pbjs.que), so when prebid.js did
//      not load (blocked, CDN error) the page sent NO ad request at all --
//      direct campaigns included (measured live 16.10.2026: 0 GAM requests).
//      Now: if Prebid has not loaded 3 s after the GPT setup, the first-screen
//      slots go to GAM without bids; if Prebid is loaded, the wrapper still
//      waits for the auction exactly as before, with a hard cap of 10 s
//      (consent timeout 8 s + auction 1.5 s + margin) so a stuck auction can
//      never block GAM for good. Lazy slots and viewable refreshes get the
//      same rule; a viewable refresh goes to GAM directly when there is no Prebid.
//
//   5. TCF CMP WATCHDOG, embedded from the Alo.rs 13102026 build (= Informer
//      04092026 / Blic 04092026-2): permanent insurance against a broken CMP
//      configuration (03.09.2026 outage). Passive while the CMP works. Its
//      recovery re-sends the first-screen slots through
//      window.__bizportalAdsRecoveryRefresh. Debug: ?adsDebug=1 and
//      window.__cmpWatchdog.
//
//   6. TAG TARGETING FIX. The template writes adsKeywords.tags (an array);
//      the wrapper read adsKeywords.articleTags, so the articleTags key was
//      never sent. It is now sent from tags (articleTags still wins if the
//      template ever provides it), one value per tag.
//
//   7. LAZY OBSERVER GUARD. The template marks InText_1 "lazyAd" although it
//      is in the first-screen request; the observer ran a second Prebid
//      auction for it on every article and refreshed nothing. Now only slots
//      registered in adUnitsBTF are auctioned by the observer.
//
//   8. Adhesion 1024 px Prebid size written as [[728, 90]] instead of the
//      flat [728, 90].
//
// Nothing else changes: slots, sizes, bidders, timeouts, refresh cadence.
// =============================================================================

// Debug logging, switched on with ?adsDebug=1 in the page URL (used by the CMP watchdog below).
var ADS_DEBUG = false;
try {
    ADS_DEBUG = new URLSearchParams(window.location.search).has('adsDebug');
} catch (debugFlagError) {
    ADS_DEBUG = false;
}

function adsDebugLog() {
    if (!ADS_DEBUG || !window.console || typeof console.log !== 'function') {
        return;
    }
    var logArguments = Array.prototype.slice.call(arguments);
    logArguments.unshift('[Bizportal ads]');
    console.log.apply(console, logArguments);
}

// =============================================================================
// 16102026-5: TCF CMP WATCHDOG -- embedded from the Alo.rs 13102026 build, i.e. the standalone
// Informer.rs/04092026/cmp-watchdog.js (= the Blic 04092026-2 block).
// Runs at script execution, before the wrapper boots. Passive while the CMP
// works; see its own header below.
// =============================================================================
// =============================================================================
// STANDALONE TCF CMP WATCHDOG (v 04092026, Ringier Serbia ad ops)
// =============================================================================
//
// Purpose: when the page's CMP (consent management platform) fails to load its
// configuration, it answers every TCF query with cmpStatus "loading" forever,
// never shows a banner and never produces a consent string, while reporting
// gdprApplies = true. Consent-aware ad scripts (Google Publisher Tag, Prebid)
// then never send a single ad request and the site serves no ads at all.
// This happened across several Serbian sites on 03.09.2026.
//
// This file is the self-contained fix. It watches the CMP's own loading
// sequence: if the configuration call (cmp.php) completes but no design file
// follows, the configuration was empty for this visitor and the file answers
// all waiting ad scripts with "GDPR does not apply" (the correct resolution
// for a Serbian, non-EEA audience), rescues consumers whose callbacks are
// held inside the consentmanager registry, and re-triggers Google ad requests
// that were dropped while blocked. A visitor whose CMP IS progressing (design
// file requested, banner shown -- e.g. an EU visitor) is never touched, and a
// device set to a clearly EEA timezone is never answered synthetically. It is
// completely passive while the CMP works, and it stands down automatically
// the moment the CMP's configuration is fixed -- the file can stay on the page
// permanently as insurance.
//
// INTEGRATION: include as early as possible, ideally BEFORE gpt.js:
//   <script src=".../cmp-watchdog.min.js"></script>
// The earlier it runs, the fewer rescue paths are needed; it is safe and
// effective in any position. No configuration required. Debug state:
// window.__cmpWatchdog in the browser console.
//
// v 03092026-2: also answers consumers using the TCF postMessage protocol
// (__tcfapiCall / __tcfapiReturn via the __tcfapiLocator frame) -- on some
// pages GPT itself binds to that path and the function-level fix alone is
// not enough (verified live on sd.rs on 03.09.2026).
//
// v 03092026-3: also patches GPP (window.__gpp, the CMP's GPP registry and
// the __gppLocator postMessage protocol). The same broken CMP leaves GPP stuck
// at signalStatus "not ready", and Google Publisher Tag checks GPP
// independently of TCF -- confirmed live on sd.rs and Blic mobile, 03.09.2026.

// =============================================================================
// TCF CMP WATCHDOG
// =============================================================================
//
// Background: a consentmanager.net CMP is embedded in this site's templates.
// When its remote configuration fails to load, the CMP answers every TCF query
// with cmpStatus "loading" forever: no banner is rendered, no consent string
// is ever produced, and gdprApplies stays true. GPT and Prebid are both
// consent-aware, so in that state neither of them sends a single ad request
// and every slot on the site goes dark. This happened for real on 03.09.2026
// and cost a full ad outage.
//
// What the failure actually looks like (measured 04.09.2026): the CMP core
// script loads and its first configuration call (/delivery/cmp.php) completes
// normally, but the answer carries no configuration -- the account's designs
// are all geo-targeted and none is marked as fallback, so a visitor whose
// country matches no design gets nothing. On a healthy load the design file
// (/delivery/customdata/...) is requested within a few milliseconds of
// cmp.php finishing; on the broken load nothing ever follows cmp.php.
//
// What this watchdog does:
//
//   1. It wraps window.__tcfapi in a transparent pass-through proxy. While
//      the CMP behaves normally, the proxy changes nothing: every call and
//      every event goes straight through, and consent behavior is entirely
//      the CMP's.
//
//   2. It watches the CMP's own network activity (the design-file <script>
//      element in the DOM, and the browser's resource timeline). If cmp.php
//      has completed and no design file has been requested for
//      CMP_NO_DESIGN_CONFIRM_MILLISECONDS afterwards, the
//      CMP is in the broken state described above and the watchdog takes
//      over. This is a positive detection of the failure, not a timeout, so
//      it fires early (about 2 seconds into the page) for a broken visitor and
//      NEVER fires for a visitor whose CMP is merely slow but progressing.
//
//   3. A visitor for whom the CMP IS progressing (design file requested, or
//      the CMP's own status advanced, or a real "cmpuishown" / "tcloaded"
//      event arrived) is left entirely to the real CMP. That includes EU
//      visitors, who must see the banner and whose ads must wait for their
//      choice. The watchdog stands down for good on any such signal.
//
//   4. As a last resort, if the CMP shows no progress at all for
//      CMP_WATCHDOG_MAX_WAIT_MILLISECONDS (its scripts never loaded, the
//      vendor is entirely unreachable), the watchdog also takes over, so a
//      genuine vendor outage still cannot black out the site for the
//      non-EEA audience.
//
//   5. Before taking over it checks the visitor's device timezone. A device
//      set to an unambiguously EEA/CH/UK timezone (Berlin, Vienna, Zurich,
//      Paris, ...) is never answered synthetically: for that visitor the
//      watchdog does nothing, and if the CMP cannot serve them they get no
//      ads rather than ads without consent. Timezones that Serbian devices
//      commonly report (the Windows "Belgrade, Bratislava, Budapest,
//      Ljubljana, Prague" group maps to Europe/Budapest on many machines)
//      are deliberately NOT on that list, so a Serbian visitor is never
//      denied ads by this check. It is a fail-safe, not a geo lookup.
//
//   6. On takeover, every TCF consumer that registered through the proxy
//      (GPT, Prebid) immediately receives a synthetic final answer with
//      gdprApplies = false, and every later TCF call is answered the same
//      way. gdprApplies = false is the correct resolution for this site's
//      overwhelmingly Serbian (non-EEA) audience and is exactly how the
//      working consentmanager instances on this network resolve for them.
//
//   7. It is self-healing in both directions. If the account is fixed, the
//      design file arrives on every load and the watchdog never fires. If the
//      real CMP asserts itself after a takeover (a genuine "cmpuishown" or
//      final event), the proxy returns to pass-through, the synthetic answers
//      stop, and the GPT recovery refresh is never issued.
//
// Known limitation, accepted: a consumer that registered its listener
// directly with the broken CMP BEFORE this wrapper executed cannot be
// notified through the proxy; the consentmanager registry rescue below
// covers that case for this vendor specifically.
//
// Debugging: window.__cmpWatchdog exposes
// { wrapped, takenOver, cmpFinal, cmpHealthy, takeoverReason, timezone, timezoneBlocked }.

// After the CMP's configuration call (cmp.php) has completed, how long to wait
// for the design file request before concluding the configuration was empty.
// On a healthy load the design file follows within ~10 ms; 750 ms is a very
// wide margin.
var CMP_NO_DESIGN_CONFIRM_MILLISECONDS = 750;

// Absolute ceiling: if the CMP has shown no progress of any kind for this
// long after the proxy was installed, take over anyway (vendor unreachable).
// Generous on purpose: an EU visitor on a slow connection may need several
// seconds just for cmp.php (measured 2.6 s from Germany), and taking over
// before that would bypass their banner. Serbian visitors on the broken
// instance are not affected by this value at all -- their takeover comes from
// the empty-configuration signature at ~2 s.
var CMP_WATCHDOG_MAX_WAIT_MILLISECONDS = 8000;

// How often the watchdog re-evaluates the CMP's progress.
var CMP_WATCHDOG_POLL_MILLISECONDS = 250;

// Device timezones that identify an EEA/CH/UK visitor beyond reasonable doubt.
// The synthetic "GDPR does not apply" answer is never given to these. The
// list intentionally omits every zone a Serbian device might report:
// Europe/Belgrade itself, and the Windows group-default zones Europe/Budapest
// (Belgrade/Bratislava/Budapest/Ljubljana/Prague group) and Europe/Warsaw
// (Sarajevo/Skopje/Warsaw/Zagreb group), plus Prague, Bratislava, Ljubljana
// and Zagreb which share those groups.
var CMP_WATCHDOG_EEA_DEVICE_TIMEZONES = [
    'Europe/Berlin', 'Europe/Vienna', 'Europe/Zurich', 'Europe/Amsterdam',
    'Europe/Brussels', 'Europe/Luxembourg', 'Europe/Paris', 'Europe/Madrid',
    'Europe/Rome', 'Europe/Malta', 'Europe/Copenhagen', 'Europe/Stockholm',
    'Europe/Oslo', 'Europe/Helsinki', 'Europe/Athens', 'Europe/Bucharest',
    'Europe/Sofia', 'Europe/Vilnius', 'Europe/Riga', 'Europe/Tallinn',
    'Europe/Dublin', 'Europe/London', 'Europe/Lisbon', 'Atlantic/Reykjavik',
    'Atlantic/Madeira', 'Atlantic/Azores', 'Atlantic/Canary', 'Europe/Nicosia',
    'Asia/Nicosia', 'Europe/Vaduz'
];

// The CMP stub is normally installed by the template before this file runs,
// but load order is not guaranteed. If window.__tcfapi is not there yet, the
// watchdog polls for it this often, for at most this long, then gives up
// (no CMP on the page means nothing blocks ad serving and there is nothing
// to guard).
var CMP_APPEARANCE_POLL_MILLISECONDS = 200;
var CMP_APPEARANCE_MAX_WAIT_MILLISECONDS = 10000;

(function installCmpWatchdog() {

    // Read-only state for debugging from the console / remote sessions.
    var watchdogState = {
        wrapped: false,
        takenOver: false,
        cmpFinal: false,
        cmpHealthy: false,
        takeoverReason: null,
        timezone: null,
        timezoneBlocked: false
    };
    window.__cmpWatchdog = watchdogState;

    // The CMP's own __tcfapi function once the proxy is installed.
    var realTcfApi = null;

    // Every listener registered through the proxy, so the watchdog can answer
    // them itself on takeover. Each entry is { callback, syntheticListenerId }.
    var proxiedListeners = [];

    // Synthetic listener ids start high so they can never collide with ids
    // handed out by the real CMP.
    var nextSyntheticListenerId = 100000;

    // The progress poll timer, and when the proxy was installed (poll clock).
    var progressPollTimer = null;
    var proxyInstalledAtMilliseconds = 0;

    // Bizportal: logs only with ?adsDebug=1, through the wrapper's logger.
    function logWatchdog(message) {
        try {
            adsDebugLog('[cmp-watchdog] ' + message);
        } catch (ignored) {}
    }

    function nowMilliseconds() {
        return new Date().getTime();
    }

    // True while the watchdog's synthetic answers are in force: it has taken
    // over AND the real CMP has neither finished nor asserted itself since.
    function syntheticAnswersActive() {
        return watchdogState.takenOver && !watchdogState.cmpFinal && !watchdogState.cmpHealthy;
    }

    // -------------------------------------------------------------------------
    // Device timezone fail-safe (see point 5 in the header comment).
    // -------------------------------------------------------------------------
    function readDeviceTimezone() {
        try {
            var intlObject = window.Intl || (typeof Intl !== 'undefined' ? Intl : null);
            if (!intlObject || typeof intlObject.DateTimeFormat !== 'function') {
                return null;
            }
            var resolved = intlObject.DateTimeFormat().resolvedOptions();
            if (resolved && typeof resolved.timeZone === 'string' && resolved.timeZone.length > 0) {
                return resolved.timeZone;
            }
        } catch (timezoneError) {
            return null;
        }
        return null;
    }

    function deviceLooksEea() {
        var timezone = readDeviceTimezone();
        watchdogState.timezone = timezone;
        if (timezone === null) {
            // Unknown timezone (very old browser): cannot tell, do not block.
            return false;
        }
        var zoneIndex;
        for (zoneIndex = 0; zoneIndex < CMP_WATCHDOG_EEA_DEVICE_TIMEZONES.length; zoneIndex++) {
            if (CMP_WATCHDOG_EEA_DEVICE_TIMEZONES[zoneIndex] === timezone) {
                return true;
            }
        }
        return false;
    }

    // -------------------------------------------------------------------------
    // CMP progress detection through the resource timeline and the CMP's own
    // public state (see points 2-4 in the header comment).
    // -------------------------------------------------------------------------

    // Returns { configCallCompletedAt: ms-since-page-start or null,
    //           designFileRequested: bool }.
    //
    // The design file is requested by the CMP core as an async <script>
    // element appended to the document the moment cmp.php has executed
    // (measured: 2 ms later). Its download can take several seconds on a slow
    // connection, and a resource-timeline entry only exists once a download
    // has COMPLETED -- so an in-flight design file is invisible in the
    // timeline. The DOM is therefore checked first: a <script> whose src is a
    // consentmanager /delivery/customdata/ URL means the configuration
    // arrived and a design is being fetched, i.e. the CMP is working for this
    // visitor, whether or not the file has finished downloading yet.
    function inspectCmpNetworkActivity() {
        var result = { configCallCompletedAt: null, designFileRequested: false };
        try {
            var scriptElements = document.getElementsByTagName('script');
            var scriptIndex;
            for (scriptIndex = 0; scriptIndex < scriptElements.length; scriptIndex++) {
                var scriptSource = String(scriptElements[scriptIndex].src || '');
                if (scriptSource.indexOf('consentmanager') !== -1 && scriptSource.indexOf('/delivery/customdata/') !== -1) {
                    result.designFileRequested = true;
                    break;
                }
            }
        } catch (domError) {
            // fall through to the timeline check
        }
        try {
            if (!window.performance || typeof window.performance.getEntriesByType !== 'function') {
                return result;
            }
            var resourceEntries = window.performance.getEntriesByType('resource');
            var entryIndex;
            for (entryIndex = 0; entryIndex < resourceEntries.length; entryIndex++) {
                var resourceName = String(resourceEntries[entryIndex].name);
                if (resourceName.indexOf('consentmanager') === -1) {
                    continue;
                }
                if (resourceName.indexOf('/delivery/cmp.php') !== -1) {
                    // responseEnd is exposed for cross-origin resources even
                    // without Timing-Allow-Origin; a still-in-flight request
                    // does not appear in the timeline at all.
                    var responseEnd = resourceEntries[entryIndex].responseEnd;
                    if (typeof responseEnd === 'number' && responseEnd > 0) {
                        if (result.configCallCompletedAt === null || responseEnd < result.configCallCompletedAt) {
                            result.configCallCompletedAt = responseEnd;
                        }
                    }
                }
                if (resourceName.indexOf('/delivery/customdata/') !== -1 || resourceName.indexOf('/delivery/info/') !== -1) {
                    result.designFileRequested = true;
                }
            }
        } catch (performanceError) {
            return result;
        }
        return result;
    }

    // The consentmanager core exposes window.cmpmngr.status: it stays at 1 in
    // the broken state and advances (4 = banner shown, 6 = finished) once the
    // configuration has arrived. Any advance beyond 1 is progress.
    function cmpVendorStatusAdvanced() {
        try {
            var cmpVendorObject = window.cmpmngr;
            if (cmpVendorObject && typeof cmpVendorObject.status === 'number' && cmpVendorObject.status > 1) {
                return true;
            }
        } catch (statusError) {
            return false;
        }
        return false;
    }

    // Milliseconds since the page's time origin, on the same clock as the
    // resource timeline entries.
    function millisecondsSincePageStart() {
        try {
            if (window.performance && typeof window.performance.now === 'function') {
                return window.performance.now();
            }
        } catch (performanceError) {
            return 0;
        }
        return 0;
    }

    // Marks the CMP as genuinely working for this visitor and stands the
    // watchdog down permanently. Called on any progress signal.
    function markCmpHealthy(reason) {
        if (watchdogState.cmpHealthy) {
            return;
        }
        watchdogState.cmpHealthy = true;
        stopProgressPoll();
        if (watchdogState.takenOver) {
            logWatchdog('real CMP asserted itself after a takeover (' + reason + '); synthetic answers withdrawn, proxy back to pass-through.');
        } else {
            logWatchdog('CMP is progressing on its own (' + reason + '); watchdog stood down.');
        }
    }

    function stopProgressPoll() {
        if (progressPollTimer !== null) {
            clearInterval(progressPollTimer);
            progressPollTimer = null;
        }
    }

    // One evaluation of the CMP's progress; runs every
    // CMP_WATCHDOG_POLL_MILLISECONDS until a decision is reached.
    function evaluateCmpProgress() {
        if (watchdogState.cmpFinal || watchdogState.cmpHealthy || watchdogState.takenOver) {
            stopProgressPoll();
            return;
        }

        if (cmpVendorStatusAdvanced()) {
            markCmpHealthy('cmpmngr.status advanced past 1');
            return;
        }

        var networkActivity = inspectCmpNetworkActivity();
        if (networkActivity.designFileRequested) {
            markCmpHealthy('design file requested');
            return;
        }

        var elapsedSinceInstall = nowMilliseconds() - proxyInstalledAtMilliseconds;

        if (networkActivity.configCallCompletedAt !== null) {
            var sinceConfigCall = millisecondsSincePageStart() - networkActivity.configCallCompletedAt;
            if (sinceConfigCall >= CMP_NO_DESIGN_CONFIRM_MILLISECONDS) {
                takeOver('cmp.php completed ' + Math.round(sinceConfigCall) + 'ms ago and no design file followed (empty configuration for this visitor)');
                return;
            }
        }

        if (elapsedSinceInstall >= CMP_WATCHDOG_MAX_WAIT_MILLISECONDS) {
            takeOver('no CMP progress of any kind within ' + CMP_WATCHDOG_MAX_WAIT_MILLISECONDS + 'ms (vendor unreachable)');
            return;
        }
    }

    // A minimal but complete TCData object representing "GDPR does not apply".
    // Consumers only read gdprApplies/eventStatus/cmpStatus in this case, but
    // the usual containers are present so nothing trips over a missing field.
    function buildSyntheticTcData() {
        return {
            // Marker so the watchdog's own observers can tell a synthetic
            // answer from a genuine CMP recovery; harmless extra field for
            // every other TCF consumer.
            syntheticWatchdogAnswer: true,
            tcString: '',
            tcfPolicyVersion: 4,
            cmpId: 31,
            cmpVersion: 1,
            gdprApplies: false,
            eventStatus: 'tcloaded',
            cmpStatus: 'loaded',
            isServiceSpecific: true,
            useNonStandardTexts: false,
            publisherCC: 'RS',
            purposeOneTreatment: false,
            listenerId: null,
            purpose: { consents: {}, legitimateInterests: {} },
            vendor: { consents: {}, legitimateInterests: {} },
            specialFeatureOptins: {},
            publisher: {
                consents: {},
                legitimateInterests: {},
                customPurpose: { consents: {}, legitimateInterests: {} },
                restrictions: {}
            }
        };
    }

    function answerListenerSynthetically(listenerEntry) {
        var syntheticData = buildSyntheticTcData();
        syntheticData.listenerId = listenerEntry.syntheticListenerId;
        try {
            listenerEntry.callback(syntheticData, true);
        } catch (listenerError) {
            logWatchdog('a TCF listener threw while receiving the synthetic answer: ' + listenerError);
        }
    }

    // After a takeover, the proxy can only answer consumers that registered
    // THROUGH it. A consumer that registered before this file executed (GPT's
    // pubads implementation wins that race on some page loads) left its
    // callback inside the real CMP's own registry, forever waiting -- the
    // proxy cannot reach it. For the consentmanager CMP specifically, that
    // registry is publicly reachable at window.cmpmngr.api.events as entries
    // of shape { type: 'tcfv2', listener: function, id: number }, so the
    // watchdog answers those held listeners directly as well. Every step is
    // guarded: any unexpected shape (different CMP vendor, changed internals
    // after a consentmanager update) simply skips the rescue and the proxy
    // path still covers consumers that registered normally. A consumer that
    // registered through the proxy also appears in this registry and will
    // receive the synthetic answer twice; TCF listeners are event streams and
    // both GPT and Prebid handle a repeated final event idempotently.
    // Registry entries already answered, keyed by the CMP's own listener id, so
    // retries never answer the same consumer twice.
    var rescuedRegistryIds = {};

    function rescueCmpHeldListeners() {
        var rescuedCount = 0;
        try {
            var cmpVendorObject = window.cmpmngr;
            if (!cmpVendorObject || !cmpVendorObject.api || !cmpVendorObject.api.events || typeof cmpVendorObject.api.events.forEach !== 'function') {
                return 0;
            }
            cmpVendorObject.api.events.forEach(function (registryEntry) {
                if (!registryEntry || registryEntry.type !== 'tcfv2' || typeof registryEntry.listener !== 'function') {
                    return;
                }
                if (rescuedRegistryIds[registryEntry.id] === true) {
                    return;
                }
                rescuedRegistryIds[registryEntry.id] = true;
                var syntheticData = buildSyntheticTcData();
                syntheticData.listenerId = registryEntry.id;
                try {
                    registryEntry.listener(syntheticData, true);
                    rescuedCount = rescuedCount + 1;
                } catch (listenerError) {
                    logWatchdog('a CMP-held TCF listener threw while receiving the synthetic answer: ' + listenerError);
                }
            });
        } catch (rescueError) {
            logWatchdog('CMP-held listener rescue skipped: ' + rescueError);
        }
        return rescuedCount;
    }

    // The registry (window.cmpmngr) belongs to the CMP's full code, which loads
    // over the network and can appear AFTER the takeover fired -- and consumers
    // held in the CMP's stub queue only land in the registry when that code
    // processes the queue. A single rescue pass at takeover therefore misses
    // late arrivals (verified live on 03.09.2026: same build freed GPT on one
    // site and missed it on the other purely by load timing). So the rescue
    // repeats every second for a while after takeover, answering each newly
    // appeared captive listener exactly once, and stops early if the CMP
    // genuinely recovers or asserts itself.
    var CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS = 1000;
    var CMP_RESCUE_MAX_DURATION_MILLISECONDS = 30000;


    // Ad requests that GPT attempted WHILE it was still consent-blocked are
    // dropped, not queued -- freeing GPT afterwards does not resend them
    // (verified live on 03.09.2026: one site's request timing landed after the
    // rescue and rendered, the other site's landed before it and stayed blank
    // with zero gampad requests). So after the first rescue pass that actually
    // freed listeners, wait a moment and check whether ANY ad request has left
    // the page; if none has, issue a single recovery refresh of all GPT slots.
    // The completed Prebid auctions' targeting is already set on the slots, so
    // the recovery request serves with full header-bidding competition.
    // Never issued once the real CMP has asserted itself: for that visitor
    // ad requests must wait for the real consent outcome.
    var gptRedispatchScheduled = false;

    function scheduleGptRedispatchIfSilent() {
        if (gptRedispatchScheduled) {
            return;
        }
        gptRedispatchScheduled = true;
        setTimeout(function () {
            try {
                if (!syntheticAnswersActive()) {
                    logWatchdog('real CMP is in charge; recovery refresh not issued.');
                    return;
                }
                var observedAdRequestCount = 0;
                try {
                    var resourceEntries = [];
                    if (window.performance && typeof window.performance.getEntriesByType === 'function') {
                        resourceEntries = window.performance.getEntriesByType('resource');
                    }
                    var entryIndex;
                    for (entryIndex = 0; entryIndex < resourceEntries.length; entryIndex++) {
                        if (String(resourceEntries[entryIndex].name).indexOf('gampad/ads') !== -1) {
                            observedAdRequestCount = observedAdRequestCount + 1;
                        }
                    }
                } catch (performanceError) {
                    observedAdRequestCount = 0;
                }
                if (observedAdRequestCount > 0) {
                    logWatchdog('GPT already dispatched ' + observedAdRequestCount + ' ad request(s); no recovery refresh needed.');
                    return;
                }
                // Bizportal: the wrapper re-sends its own first-screen slots.
                // A blanket refresh() would also request every lazy slot far
                // below the fold at once.
                if (typeof window.__bizportalAdsRecoveryRefresh === 'function') {
                    window.__bizportalAdsRecoveryRefresh();
                    logWatchdog('GPT sent no ad requests while consent was blocked; asked the wrapper to re-send its first-screen slots.');
                    return;
                }
                if (window.googletag && window.googletag.cmd) {
                    window.googletag.cmd.push(function () {
                        window.googletag.pubads().refresh();
                    });
                    logWatchdog('GPT sent no ad requests while consent was blocked; issued a one-time recovery refresh of all slots.');
                }
            } catch (redispatchError) {
                logWatchdog('GPT recovery refresh skipped: ' + redispatchError);
            }
        }, 1500);
    }

    function startCmpRegistryRescueLoop() {
        var firstPassCount = rescueCmpHeldListeners() + rescueGppRegistryListeners();
        if (firstPassCount > 0) {
            logWatchdog('rescued ' + firstPassCount + ' listener(s) held inside the CMP registry (consumers that registered before this file executed).');
            scheduleGptRedispatchIfSilent();
        }
        var elapsedMilliseconds = 0;
        var rescueTimer = setInterval(function () {
            if (!syntheticAnswersActive()) {
                clearInterval(rescueTimer);
                return;
            }
            var passCount = rescueCmpHeldListeners() + rescueGppRegistryListeners();
            if (passCount > 0) {
                logWatchdog('rescued ' + passCount + ' more CMP-held listener(s) on a retry pass.');
                scheduleGptRedispatchIfSilent();
            }
            elapsedMilliseconds = elapsedMilliseconds + CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS;
            if (elapsedMilliseconds >= CMP_RESCUE_MAX_DURATION_MILLISECONDS) {
                clearInterval(rescueTimer);
            }
        }, CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS);
    }

    // Marks the CMP as finished and stands the watchdog down. Called whenever a
    // real final event is observed through the proxy.
    function markCmpFinal() {
        if (watchdogState.cmpFinal) {
            return;
        }
        watchdogState.cmpFinal = true;
        stopProgressPoll();
        logWatchdog('CMP reached a final state on its own; watchdog stood down.');
    }

    function takeOver(reason) {
        if (watchdogState.takenOver || watchdogState.cmpFinal || watchdogState.cmpHealthy) {
            return;
        }
        stopProgressPoll();

        // Fail-safe: never bypass consent for a device that is clearly in the
        // EEA. For that visitor the watchdog does nothing at all.
        if (deviceLooksEea()) {
            watchdogState.timezoneBlocked = true;
            logWatchdog('CMP looks broken (' + reason + ') but the device timezone is ' + watchdogState.timezone +
                ' (EEA); leaving consent to the real CMP, no synthetic answer for this visitor.');
            return;
        }

        watchdogState.takenOver = true;
        watchdogState.takeoverReason = reason;
        logWatchdog(
            'taking over: ' + reason + '; answering ' + proxiedListeners.length +
            ' registered TCF listener(s) with gdprApplies=false so ad serving can proceed.');
        var listenerIndex;
        for (listenerIndex = 0; listenerIndex < proxiedListeners.length; listenerIndex++) {
            answerListenerSynthetically(proxiedListeners[listenerIndex]);
        }
        takeOverGpp();
        startCmpRegistryRescueLoop();
    }

    // Watches a real CMP event. Final states per the TCF spec are "tcloaded"
    // (no UI needed) and "useractioncomplete" (user answered the banner).
    // "cmpuishown" is not final but proves the CMP is configured and working
    // for this visitor, so it counts as the CMP asserting itself.
    function observeRealEvent(tcData) {
        // A synthetic answer produced by this watchdog (delivered back to us
        // through the CMP registry rescue) must never count as the CMP
        // recovering -- only genuine CMP events may stand the watchdog down.
        if (tcData && tcData.syntheticWatchdogAnswer) {
            return;
        }
        if (!tcData) {
            return;
        }
        if (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete') {
            markCmpHealthy('real final event ' + tcData.eventStatus);
            markCmpFinal();
            return;
        }
        if (tcData.eventStatus === 'cmpuishown' || tcData.cmpStatus === 'loaded') {
            markCmpHealthy('real event ' + tcData.eventStatus + ' / cmpStatus ' + tcData.cmpStatus);
        }
    }



    // Consumers inside iframes -- and, on some pages, GPT itself -- talk to
    // the CMP through the TCF postMessage protocol aimed at the
    // __tcfapiLocator frame instead of calling window.__tcfapi directly.
    // Those requests never pass through the function proxy above, so after a
    // takeover the watchdog answers them here as well. Verified live on sd.rs
    // (03.09.2026): GPT bound itself to the postMessage path and stayed
    // blocked even after the function-path rescue -- __tcfapiCall messages
    // flowed with ZERO __tcfapiReturn replies from the broken CMP. While the
    // CMP is healthy (or before a takeover) this responder stays silent, and
    // it stands down permanently if the real CMP asserts itself.
    function installPostMessageResponder() {
        window.addEventListener('message', function (messageEvent) {
            if (!syntheticAnswersActive()) {
                return;
            }
            var payload = messageEvent && messageEvent.data;
            var usedJsonEncoding = false;
            if (typeof payload === 'string') {
                if (payload.indexOf('__tcfapiCall') === -1) {
                    return;
                }
                try {
                    payload = JSON.parse(payload);
                    usedJsonEncoding = true;
                } catch (parseError) {
                    return;
                }
            }
            if (!payload || !payload.__tcfapiCall || !messageEvent.source) {
                return;
            }
            var tcfCall = payload.__tcfapiCall;
            var returnValue;
            if (tcfCall.command === 'ping') {
                returnValue = {
                    gdprApplies: false,
                    cmpLoaded: true,
                    cmpStatus: 'loaded',
                    displayStatus: 'disabled',
                    apiVersion: '2.2',
                    cmpId: 31
                };
            } else {
                returnValue = buildSyntheticTcData();
            }
            var reply = { __tcfapiReturn: { returnValue: returnValue, success: true, callId: tcfCall.callId } };
            try {
                messageEvent.source.postMessage(usedJsonEncoding ? JSON.stringify(reply) : reply, '*');
            } catch (postError) {
                return;
            }
            // A consumer reached through this path may also have had its ad
            // requests dropped while blocked; make sure the one-time recovery
            // refresh check runs for this path too.
            if (tcfCall.command === 'addEventListener' || tcfCall.command === 'getTCData') {
                scheduleGptRedispatchIfSilent();
            }
        }, false);
    }

    // =========================================================================
    // GPP (GLOBAL PRIVACY PLATFORM) WATCHDOG
    // =========================================================================
    //
    // The same broken CMP that blocks TCF also implements a second, independent
    // consent signal API: GPP (Global Privacy Platform, used for US state
    // privacy laws and other non-EU frameworks). It fails identically:
    // window.__gpp answers every query with cmpStatus "loading" and
    // signalStatus "not ready" forever. Google Publisher Tag consults GPP in
    // addition to TCF before it will request ads, so even after the TCF
    // watchdog above frees GPT, a stuck GPP signal can still block ad serving
    // on its own. Confirmed live on sd.rs on 03.09.2026: TCF was fully
    // resolved (registry rescue answered every tcfv2 listener, prebid ran a
    // complete auction), yet zero ad requests ever fired until GPP was also
    // freed here.
    //
    // Mirrors the TCF watchdog's three surfaces -- the window.__gpp function,
    // the consentmanager registry (entries with type 'gpp'), and the
    // postMessage protocol via the __gppLocator frame -- and fires on the same
    // takeover as TCF. A healthy GPP resolves on its own and this code never
    // engages.

    var gppRealApi = null;
    var gppProxiedListeners = [];
    var gppNextSyntheticListenerId = 300000;
    var gppRescuedRegistryIds = {};

    // A resolved-and-nothing-applies GPP signal: no section of any privacy
    // framework currently applies, which is the correct declaration when the
    // audience is not covered by the regulations GPP encodes (this wrapper's
    // watchdog already declares the TCF/GDPR equivalent above for the same
    // non-EEA audience).
    function buildSyntheticGppPingData() {
        return {
            gppVersion: '1.1',
            cmpStatus: 'loaded',
            cmpDisplayStatus: 'hidden',
            signalStatus: 'ready',
            supportedAPIs: [],
            cmpId: 31,
            sectionList: [],
            applicableSections: [],
            gppString: '',
            parsedSections: {}
        };
    }

    // GPP's addEventListener callback receives an "event" object, not the ping
    // data directly. Different integrations read either event.data (spec says
    // a plain 'ready' string for the signalStatus event) or the ping-shaped
    // fields nested under event.pingData -- both are populated here, same
    // belt-and-braces approach as the TCF synthetic answer above.
    function buildSyntheticGppEvent(listenerId) {
        return {
            eventName: 'signalStatus',
            listenerId: listenerId,
            data: 'ready',
            pingData: buildSyntheticGppPingData()
        };
    }

    function answerGppListenerSynthetically(listenerEntry) {
        try {
            listenerEntry.callback(buildSyntheticGppEvent(listenerEntry.syntheticListenerId), true);
        } catch (listenerError) {
            logWatchdog('a GPP listener threw while receiving the synthetic answer: ' + listenerError);
        }
    }

    function takeOverGpp() {
        var listenerIndex;
        for (listenerIndex = 0; listenerIndex < gppProxiedListeners.length; listenerIndex++) {
            answerGppListenerSynthetically(gppProxiedListeners[listenerIndex]);
        }
        rescueGppRegistryListeners();
    }

    // Same shape as the TCF registry rescue, filtered to type 'gpp' entries;
    // deduped by registry id so a repeat retry pass never answers twice.
    function rescueGppRegistryListeners() {
        var rescuedCount = 0;
        try {
            var cmpVendorObject = window.cmpmngr;
            if (!cmpVendorObject || !cmpVendorObject.api || !cmpVendorObject.api.events || typeof cmpVendorObject.api.events.forEach !== 'function') {
                return 0;
            }
            cmpVendorObject.api.events.forEach(function (registryEntry) {
                if (!registryEntry || registryEntry.type !== 'gpp' || typeof registryEntry.listener !== 'function') {
                    return;
                }
                if (gppRescuedRegistryIds[registryEntry.id] === true) {
                    return;
                }
                gppRescuedRegistryIds[registryEntry.id] = true;
                try {
                    registryEntry.listener(buildSyntheticGppEvent(registryEntry.id), true);
                    rescuedCount = rescuedCount + 1;
                } catch (listenerError) {
                    logWatchdog('a CMP-held GPP listener threw while receiving the synthetic answer: ' + listenerError);
                }
            });
        } catch (rescueError) {
            logWatchdog('GPP registry rescue skipped: ' + rescueError);
        }
        return rescuedCount;
    }

    function installGppProxy() {
        if (typeof window.__gpp !== 'function') {
            return;
        }
        gppRealApi = window.__gpp;

        window.__gpp = function proxiedGpp(command, callback, parameter) {

            if (command === 'addEventListener' && typeof callback === 'function') {
                var listenerEntry = {
                    callback: callback,
                    syntheticListenerId: gppNextSyntheticListenerId
                };
                gppNextSyntheticListenerId = gppNextSyntheticListenerId + 1;
                gppProxiedListeners.push(listenerEntry);

                if (syntheticAnswersActive()) {
                    answerGppListenerSynthetically(listenerEntry);
                }

                gppRealApi(command, function (event, success) {
                    if (syntheticAnswersActive()) {
                        return;
                    }
                    callback(event, success);
                }, parameter);
                return;
            }

            if (command === 'removeEventListener') {
                var entryIndex;
                for (entryIndex = 0; entryIndex < gppProxiedListeners.length; entryIndex++) {
                    if (gppProxiedListeners[entryIndex].syntheticListenerId === parameter) {
                        gppProxiedListeners.splice(entryIndex, 1);
                        if (typeof callback === 'function') {
                            callback(true);
                        }
                        return;
                    }
                }
                gppRealApi(command, callback, parameter);
                return;
            }

            if (syntheticAnswersActive()) {
                if (typeof callback === 'function') {
                    callback(buildSyntheticGppPingData(), true);
                    return;
                }
                return;
            }

            gppRealApi(command, callback, parameter);
        };
    }

    // Consumers reaching GPP through postMessage (__gppCall / __gppReturn via
    // the __gppLocator frame), same reasoning as the TCF postMessage responder
    // above: some consumers, including GPT itself on some page loads, never
    // call window.__gpp directly.
    function installGppPostMessageResponder() {
        window.addEventListener('message', function (messageEvent) {
            if (!syntheticAnswersActive()) {
                return;
            }
            var payload = messageEvent && messageEvent.data;
            var usedJsonEncoding = false;
            if (typeof payload === 'string') {
                if (payload.indexOf('__gppCall') === -1) {
                    return;
                }
                try {
                    payload = JSON.parse(payload);
                    usedJsonEncoding = true;
                } catch (parseError) {
                    return;
                }
            }
            if (!payload || !payload.__gppCall || !messageEvent.source) {
                return;
            }
            var gppCallInfo = payload.__gppCall;
            var returnValue = gppCallInfo.command === 'addEventListener'
                ? buildSyntheticGppEvent(gppCallInfo.callId)
                : buildSyntheticGppPingData();
            var reply = { __gppReturn: { returnValue: returnValue, success: true, callId: gppCallInfo.callId } };
            try {
                messageEvent.source.postMessage(usedJsonEncoding ? JSON.stringify(reply) : reply, '*');
            } catch (postError) {
                return;
            }
            scheduleGptRedispatchIfSilent();
        }, false);
    }


    function installProxy() {
        realTcfApi = window.__tcfapi;
        watchdogState.wrapped = true;
        installPostMessageResponder();
        installGppProxy();
        installGppPostMessageResponder();

        window.__tcfapi = function proxiedTcfApi(command, version, callback, parameter) {

            // --- addEventListener -------------------------------------------
            // Record the consumer so the watchdog can answer it on takeover,
            // and ALWAYS forward the registration to the real CMP so that a
            // healthy (or later-asserting) CMP drives the consumer normally.
            if (command === 'addEventListener' && typeof callback === 'function') {
                var listenerEntry = {
                    callback: callback,
                    syntheticListenerId: nextSyntheticListenerId
                };
                nextSyntheticListenerId = nextSyntheticListenerId + 1;
                proxiedListeners.push(listenerEntry);

                if (syntheticAnswersActive()) {
                    // Late consumer after takeover: answer immediately so it
                    // never hangs, and still register with the real CMP below
                    // in case it asserts itself.
                    answerListenerSynthetically(listenerEntry);
                }

                realTcfApi(command, version, function (tcData, success) {
                    observeRealEvent(tcData);
                    // While synthetic answers are in force, suppress the CMP's
                    // eternal "loading" pings; only real progress is worth
                    // forwarding then (and observeRealEvent just lifted the
                    // suppression if this event was real progress).
                    if (syntheticAnswersActive()) {
                        return;
                    }
                    callback(tcData, success);
                }, parameter);
                return;
            }

            // --- removeEventListener ----------------------------------------
            // If the id is one of the watchdog's synthetic ids, confirm the
            // removal locally (the real CMP has never heard of that id).
            if (command === 'removeEventListener') {
                var entryIndex;
                for (entryIndex = 0; entryIndex < proxiedListeners.length; entryIndex++) {
                    if (proxiedListeners[entryIndex].syntheticListenerId === parameter) {
                        proxiedListeners.splice(entryIndex, 1);
                        if (typeof callback === 'function') {
                            callback(true);
                        }
                        return;
                    }
                }
                realTcfApi(command, version, callback, parameter);
                return;
            }

            // --- getTCData / ping / everything else -------------------------
            // While synthetic answers are in force, answer one-shot queries
            // synthetically (the real CMP would only ever say "loading"
            // again). Otherwise pure pass-through, with a peek at the answer
            // to spot progress or a final state.
            if (syntheticAnswersActive()) {
                if (command === 'ping' && typeof callback === 'function') {
                    callback({
                        gdprApplies: false,
                        cmpLoaded: true,
                        cmpStatus: 'loaded',
                        displayStatus: 'disabled',
                        apiVersion: '2.2',
                        cmpId: 31
                    }, true);
                    return;
                }
                if (typeof callback === 'function') {
                    callback(buildSyntheticTcData(), true);
                    return;
                }
                return;
            }

            realTcfApi(command, version, function (tcData, success) {
                observeRealEvent(tcData);
                if (typeof callback === 'function') {
                    callback(tcData, success);
                }
            }, parameter);
        };

        // The watchdog's own observer: register with the real CMP so progress
        // or a final state is noticed even if no other consumer ever registers.
        realTcfApi('addEventListener', 2, function (tcData, success) {
            if (success !== false) {
                observeRealEvent(tcData);
            }
        });

        proxyInstalledAtMilliseconds = nowMilliseconds();
        progressPollTimer = setInterval(evaluateCmpProgress, CMP_WATCHDOG_POLL_MILLISECONDS);
        logWatchdog('proxy installed; watching CMP progress (takeover ' + CMP_NO_DESIGN_CONFIRM_MILLISECONDS +
            'ms after an empty configuration answer, or after ' + CMP_WATCHDOG_MAX_WAIT_MILLISECONDS + 'ms without any progress).');
    }

    // The CMP stub normally exists before this file runs; if not, poll for a
    // while in case the template loads it late. No CMP at all means nothing
    // blocks ad serving, so the watchdog simply never engages.
    if (typeof window.__tcfapi === 'function') {
        installProxy();
    } else {
        var appearanceWaitedMilliseconds = 0;
        var appearancePollTimer = setInterval(function () {
            if (typeof window.__tcfapi === 'function') {
                clearInterval(appearancePollTimer);
                installProxy();
                return;
            }
            appearanceWaitedMilliseconds = appearanceWaitedMilliseconds + CMP_APPEARANCE_POLL_MILLISECONDS;
            if (appearanceWaitedMilliseconds >= CMP_APPEARANCE_MAX_WAIT_MILLISECONDS) {
                clearInterval(appearancePollTimer);
                logWatchdog('no __tcfapi appeared within ' + CMP_APPEARANCE_MAX_WAIT_MILLISECONDS + 'ms; nothing to guard.');
            }
        }, CMP_APPEARANCE_POLL_MILLISECONDS);
    }
})();

// =============================================================================
// end of the embedded TCF CMP WATCHDOG
// =============================================================================

// Normal case: Load deferred after window.load() event.
window.addEventListener('load', function(e) {
    //console.log('Ad Wrapper: Window load event.');
    if (!window.prebidAuctionRun) {
        //console.log('Ad Wrapper: Running Prebid auction on load event...');
        window.prebidAuctionRun = true;
        clearTimeout(window.adsLoadTimer);
        runWrapper();
    }
});

// If it's taking too long, go ahead and load deferred before window.load() event occurs.
document.addEventListener('DOMContentLoaded', function(e) {
    //console.log('Ad Wrapper: Document ready event.');
    window.adsLoadTimer = setTimeout(function() {
        if (!window.prebidAuctionRun) {
            //console.warn('Ad Wrapper: Running Prebid auction due to timeout...');
            window.prebidAuctionRun = true;
            runWrapper();
        }
    }, 2000);
});

// Reference to the global command queue for asynchronous execution of GPT-related calls.
var googletag = googletag || {};
googletag.cmd = googletag.cmd || [];

// Reference to the global command queue for asynchronous execution of Prebid-related calls.
var pbjs = pbjs || {};
pbjs.que = pbjs.que || [];

// Amount of time (ms) that Prebid allows the bidders to respond to ad requests.
var PREBID_TIMEOUT = 1500;

// Number of seconds to wait after the slot becomes viewable.
var SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;

// Advertisers for which refresh shouldn't apply. Just add the company IDs e.g [3219368852, 3130234283].
var GAM_NOREFRESH_ADVERTISER_IDS = [];

// Campaigns for which refresh shouldn't apply. Just add the order IDs e.g [3219368852, 3130234283].
var GAM_NOREFRESH_ORDER_IDS = [];

// Ad units (div ids) for which refresh shouldn't apply. Just add the div IDs e.g ['Branding_Left', 'Branding_Right'].
var GAM_NOREFRESH_ADUNITS = ['Branding_Left', 'Branding_Right'];

// GAM without Prebid: if prebid.js has not loaded this long after the GPT setup, the first-screen
// slots are sent to GAM without bids (prebid.js blocked or failed). Same wait for a lazy slot's auction.
var PREBID_MISSING_FALLBACK_MS = 3000;

// Hard cap for the first-screen auction when Prebid IS loaded: consent timeout (8 s) + auction
// timeout (1.5 s) + margin. Normally the auction ends long before this and the timer does nothing.
var FIRST_SCREEN_HARD_CAP_MS = 10000;

// True once prebid.js has loaded and is processing its queue.
function isPrebidLoaded() {
    return !!(window.pbjs && window.pbjs.libLoaded && typeof window.pbjs.requestBids === 'function');
}

// How far should the ad be for the lazy loading to activate.
var DISTANCE_IN_PIXELS_FOR_LAZY_LOADING = "350px";

// How much (in percent) should the ad slot be viewable. 
var VISIBILITY_PERCENT_FOR_REFRESH = 0.7;

// Variables for all defined slots. 
var Adhesion;
var Billboard;
var Branding_Left;
var Branding_Right;
var P1;
var P2;
var P3;
var P4;
var P5;
var P6;
var InText_1;
var InText_2;
var InText_3;
var InText_4;
var InText_5;
var InText_6;
var InText_7;
var InText_8;
var InText_9;
var InText_10;

// Top level ad unit path. 
var adUnitPath = "/21952471017/Bizportal.rs/";

var adWindowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; //check user's screen width

// Publicis Adform SSP has one placement for desktop and one for mobile per ad unit (Alo HB sheet).
// Desktop = 1024 px and wider, the same breakpoint the Prebid size configs use.
// Publicis goes out under its own alias ('publicis'), so its request is separate from the plain
// 'adform' placements: if Adform filters the Publicis request, the plain placements still bid.
function publicisBid(desktopMid, mobileMid) {
    var mid;
    if (adWindowWidth >= 1024) {
        mid = desktopMid;
    }
    else {
        mid = mobileMid;
    }
    return { bidder: 'publicis', params: {mid: mid, priceType: 'net'} };
}

// ATF and BTF array variables. 
var adUnitsATF = [];
var adUnitsBTF = [];

// Tag values for the articleTags key, one value per tag.
function getArticleTagValues(keywords) {
    var rawTags = keywords.articleTags;

    if (rawTags === undefined || rawTags === null) {
        rawTags = keywords.tags;
    }

    if (rawTags === undefined || rawTags === null) {
        return [];
    }

    if (!Array.isArray(rawTags)) {
        rawTags = String(rawTags).split(',');
    }

    var tagValues = [];

    for (var tagIndex = 0; tagIndex < rawTags.length; tagIndex++) {
        var tagValue = String(rawTags[tagIndex]).trim();
        if (tagValue !== '') {
            tagValues.push(tagValue);
        }
    }

    return tagValues;
}

function runWrapper() {

    //console.log('Ad Wrapper: Script execution.');

    var adContainers = document.querySelectorAll('.wrapperAd'); // Find all divs which have wrapperAd class.

    googletag.cmd.push(function() { // Push the defined ad units to the GPT array.

        // Sticky GPT size mapping. 
        var sticky_mapping = googletag.sizeMapping()
        .addSize([1600, 0], [[728, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200]]) //desktop for bigger screens
        .addSize([1024, 0], [[728, 90], [750, 100]]) //desktop for smaller screens
        .addSize([469, 0], [[468, 60], [300, 50], [320, 50]]) //tablet
        .addSize([0, 0], [[300, 50], [320, 50], [300, 100], [320, 100]]) //mobile
        .build();

        // Billboard GPT size mapping.
        var billboard_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[728, 90], [970, 66], [950, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200], [980, 120], [930, 180], [970, 250], [970, 150]]) //desktop
        .addSize([469, 0], [[468, 60], [300, 50], [320, 50]]) //tablet
        .addSize([0, 0], [[300, 50], [300, 75], [320, 80], [320, 50], [300, 100], [320, 100]]) //mobile
        .build();   

        // Branding GPT size mapping.
        var branding_mapping = googletag.sizeMapping()
        .addSize([1900, 0], [[2, 1], [300, 600]]) //desktop for bigger screens
        .addSize([1600, 0], [[2, 1], [120, 600], [160, 600]]) //desktop for smaller screens
        .addSize([0, 0], []) //tablet & mobile
        .build();

        // P GPT size mapping.
        var p_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]]) //desktop
        .addSize([469, 0], [[200, 200], [250, 250], [300, 250]]) //tablet
        .addSize([0, 0], [[200, 200], [250, 250], [300, 250], [336, 280]]) //mobile
        .build();

        // P4, P5, P6 GPT size mapping.
        var p_mobile_mapping = googletag.sizeMapping()
        .addSize([1024, 0], []) //desktop
        .addSize([469, 0], [[200, 200], [250, 250], [300, 250]]) //tablet
        .addSize([0, 0], [[200, 200], [250, 250], [300, 250], [336, 280]]) //mobile
        .build();

        // InText GPT size mapping.
        var inText_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[580, 280], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //desktop
        .addSize([469, 0], [[300, 50], [320, 50], [468, 60], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //tablet
        .addSize([0, 0], [[300, 50], [300, 75], [320, 80], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //mobile
        .build();

        adContainers.forEach(function(el) { // Runs through all of the wrapperAd divs.

            // **************** Sticky GPT and Prebid definition. *******************

            if (el.id === 'Adhesion') { // Check if Adhesion div is present in body. 

                // Sticky ad unit definition
                Adhesion = googletag.defineSlot(adUnitPath + 'Sticky', [[728, 90], [970, 90], [320, 50]], 'Adhesion')
                                    .defineSizeMapping(sticky_mapping)
                                    .setTargeting('position', 'Adhesion')
                                    .setTargeting('refresh_count', '0')
                                    .addService(googletag.pubads());
                
                // Push the defined Adhesion Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'Adhesion',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1600, 0], sizes: [[728, 90], [970, 90], [750, 100], [750, 200]] }, //desktop for bigger screens
                            { minViewPort: [1024, 0], sizes: [[728, 90]] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adform', params: {mid: '1877512', priceType: 'net'}},
                            publicisBid('2307134', '2307143'), // Publicis Adform SSP: desktop mid, mobile mid.
                            {bidder: 'directmedia', params: {mid: '1931636', priceType: 'net'}},
                            {bidder: "eskimi", params: {placementId: 1583}},
                            {bidder: 'ix', params: {siteId: '1081921'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682229'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802450'}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279042}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '120620'}},
                            {bidder: 'teads', params: {pageId: 204249, placementId: 220495}},
                        ]
                    }
                );

            }

            // **************** Billboard GPT and Prebid definition. *******************

            else if (el.id === 'Billboard') { // Check if Billboard div is present in body. 

                // Billboard ad unit definition
                Billboard = googletag.defineSlot(adUnitPath + 'Billboard', [[970, 250]], 'Billboard')
                                     .defineSizeMapping(billboard_mapping)
                                     .setTargeting('position', 'Billboard')
                                     .setTargeting('refresh_count', '0')
                                     .addService(googletag.pubads());
                
                // Push the defined Billboard Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'Billboard',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adform', params: {mid: '1877513', priceType: 'net'}},
                            publicisBid('2307127', '2307135'), // Publicis Adform SSP: desktop mid, mobile mid.
                            {bidder: 'directmedia', params: {mid: '1931637', priceType: 'net'}},
                            {bidder: "eskimi", params: {placementId: 1583}},
                            {bidder: 'ix', params: {siteId: '1081922'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682230'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802451'}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279044}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '120621'}},
                            {bidder: 'teads', params: {pageId: 204249, placementId: 220495}},
                        ]
                    }
                );

            }

            // **************** Branding_Left GPT and Prebid definition. *******************

            else if (el.id === 'Branding_Left' && adWindowWidth > 1599) { // Check if Branding_Left div is present in body. 

                // Branding_Left ad unit definition
                Branding_Left = googletag.defineSlot(adUnitPath + 'Branding_Left', [[2, 1]], 'Branding_Left')
                                            .defineSizeMapping(branding_mapping)
                                            .setTargeting('position', 'Branding_Left')
                                            .setTargeting('refresh_count', '0')
                                            .addService(googletag.pubads());
            
            }

            // **************** Branding_Right GPT and Prebid definition. *******************

            else if (el.id === 'Branding_Right' && adWindowWidth > 1599) { // Check if Branding_Right div is present in body. 

                // Branding_Right ad unit definition
                Branding_Right = googletag.defineSlot(adUnitPath + 'Branding_Right', [[2, 1]], 'Branding_Right')
                                            .defineSizeMapping(branding_mapping)
                                            .setTargeting('position', 'Branding_Right')
                                            .setTargeting('refresh_count', '0')
                                            .addService(googletag.pubads());
                
            }

            // **************** P1 GPT and Prebid definition. *******************

            else if (el.id === 'P1') { // Check if P1 div is present in body. 

                // P1 ad unit definition
                P1 = googletag.defineSlot(adUnitPath + 'P1', [[300, 250]], 'P1')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P1')
                              .setTargeting('refresh_count', '0')
                              .addService(googletag.pubads());
                
                // Push the defined P1 Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'P1',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adform', params: {mid: '1877518', priceType: 'net'}},
                            publicisBid('2307128', '2307137'), // Publicis Adform SSP: desktop mid, mobile mid.
                            {bidder: 'directmedia', params: {mid: '1931638', priceType: 'net'}},
                            {bidder: "eskimi", params: {placementId: 1583}},
                            {bidder: 'ix', params: {siteId: '1081926'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682234'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802507'}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279052}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '120624'}},
                            {bidder: 'teads', params: {pageId: 204249, placementId: 220495}},
                        ]
                    }
                );

            }

            // **************** P2 GPT and Prebid definition. *******************

            else if (el.id === 'P2') { // Check if P2 div is present in body. 

                // P2 ad unit definition
                P2 = googletag.defineSlot(adUnitPath + 'P2', [[300, 250]], 'P2')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P2')
                              .setTargeting('refresh_count', '0')
                              .addService(googletag.pubads());
                
                // Push the defined P2 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P2',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adform', params: {mid: '1877519', priceType: 'net'}},
                            publicisBid('2307129', '2307138'), // Publicis Adform SSP: desktop mid, mobile mid.
                            {bidder: 'directmedia', params: {mid: '1931639', priceType: 'net'}},
                            {bidder: "eskimi", params: {placementId: 1583}},
                            {bidder: 'ix', params: {siteId: '1081927'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682235'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802509'}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279054}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '120625'}},
                            {bidder: 'teads', params: {pageId: 204249, placementId: 220495}},
                        ]
                    }
                );

            }

            // **************** P3 GPT and Prebid definition. *******************

            else if (el.id === 'P3') { // Check if P3 div is present in body. 

                // P3 ad unit definition
                P3 = googletag.defineSlot(adUnitPath + 'P3', [[300, 250]], 'P3')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P3')
                              .setTargeting('refresh_count', '0')
                              .addService(googletag.pubads());
                
                // Push the defined P3 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P3',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'adform', params: {mid: '1877520', priceType: 'net'}},
                            publicisBid('2307131', '2307140'), // Publicis Adform SSP: desktop mid, mobile mid.
                            {bidder: 'directmedia', params: {mid: '1931640', priceType: 'net'}},
                            {bidder: "eskimi", params: {placementId: 1583}},
                            {bidder: 'ix', params: {siteId: '1081928'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682236'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802510'}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279056}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '120626'}},
                            {bidder: 'teads', params: {pageId: 204249, placementId: 220495}},
                        ]
                    }
                );

            }   

            
            // **************** P4 GPT and Prebid definition. *******************

            else if (el.id === 'P4' && adWindowWidth < 1024) { // Check if P4 div is present in body. 

                // P4 ad unit definition
                P4 = googletag.defineSlot(adUnitPath + 'P4', [[300, 250]], 'P4')
                              .defineSizeMapping(p_mobile_mapping)
                              .setTargeting('position', 'P4')
                              .setTargeting('refresh_count', '0')
                              .addService(googletag.pubads());
                
                // Push the defined P4 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P4',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adform", params: { mid: "1877521", priceType: "net" } },
                            {bidder: 'directmedia', params: {mid: '1931641', priceType: 'net'}},
                            { bidder: "eskimi", params: {placementId: 1583}},
                            { bidder: "ix", params: { siteId: "1081929" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560682237" } },
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5802511" } },
                            { bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 534546, zoneId: 3279058 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "647389", pageId: "1956164", formatId: "123584" } },
                            {bidder: 'teads', params: {pageId: 204249, placementId: 220495}},
                        ]
                    }
                );

            }   

            // **************** P5 GPT and Prebid definition. *******************

            else if (el.id === 'P5' && adWindowWidth < 1024) { // Check if P5 div is present in body. 

                // P5 ad unit definition
                P5 = googletag.defineSlot(adUnitPath + 'P5', [[300, 250]], 'P5')
                              .defineSizeMapping(p_mobile_mapping)
                              .setTargeting('position', 'P5')
                              .setTargeting('refresh_count', '0')
                              .addService(googletag.pubads());
                
                // Push the defined P5 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P5',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adform", params: { mid: "1877522", priceType: "net" } },
                            {bidder: 'directmedia', params: {mid: '1931642', priceType: 'net'}},
                            { bidder: "eskimi", params: {placementId: 1583}},
                            { bidder: "ix", params: { siteId: "1081930" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560682238" } },
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5802512" } },
                            { bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 534546, zoneId: 3279060 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "647389", pageId: "1956164", formatId: "125177" } },
                            {bidder: 'teads', params: {pageId: 204249, placementId: 220495}},
                        ]
                    }
                );

            }   

            // **************** P6 GPT and Prebid definition. *******************

            else if (el.id === 'P6' && adWindowWidth < 1024) { // Check if P6 div is present in body. 

                // P6 ad unit definition
                P6 = googletag.defineSlot(adUnitPath + 'P6', [[300, 250]], 'P6')
                              .defineSizeMapping(p_mobile_mapping)
                              .setTargeting('position', 'P6')
                              .setTargeting('refresh_count', '0')
                              .addService(googletag.pubads());
                
                // Push the defined P6 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P6',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: "adform", params: { mid: "1877523", priceType: "net" } },
                            {bidder: 'directmedia', params: {mid: '1931643', priceType: 'net'}},
                            { bidder: "eskimi", params: {placementId: 1583}},
                            { bidder: "ix", params: { siteId: "1081931" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560682239" } },
                            { bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5802513" } },
                            { bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 534546, zoneId: 3279062 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "647389", pageId: "1956164", formatId: "125178" } },
                            {bidder: 'teads', params: {pageId: 204249, placementId: 220495}},
                        ]
                    }
                );

            }   

            // **************** InText_1 GPT and Prebid definition. *******************

            else if (el.id === 'InText_1') { // Check if InText_1 div is present in body. 

                // InText_1 ad unit definition
                InText_1 = googletag.defineSlot(adUnitPath + 'InText_1', [[300, 250]], 'InText_1')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_1')
                                     .setTargeting('refresh_count', '0')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_1 Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'InText_1',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'adform', params: {mid: '1877537', priceType: 'net'} },
                            publicisBid('2307132', '2307141'), // Publicis Adform SSP: desktop mid, mobile mid.
                            {bidder: 'directmedia', params: {mid: '1931667', priceType: 'net'}},
                            { bidder: "eskimi", params: {placementId: 1583}},
                            { bidder: 'ix', params: {siteId: '1081938'} },
                            { bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682246'} },
                            { bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802521'} },
                            { bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            { bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279076} },
                            { bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '120627'} },
                            { bidder: 'teads', params: {pageId: 204248, placementId: 220494} },
                        ]
                    }
                );

            }

            // **************** InText_2 GPT and Prebid definition. *******************

            else if (el.id === 'InText_2') { // Check if InText_2 div is present in body. 

                // InText_2 ad unit definition
                InText_2 = googletag.defineSlot(adUnitPath + 'InText_2', [[300, 250]], 'InText_2')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_2')
                                     .setTargeting('refresh_count', '0')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_2 Prebid placement IDs to the BTF array (lazy loaded, like the template's lazyAd div).      
                adUnitsBTF.push(
                    {   code: 'InText_2',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        // Bidders = the live (not deleted) columns of the Bizportal.rs tab in the Alo HB sheet.
                        // Criteo, SMN, Xandr and Yandex are marked deleted there; Direct Media and Rich Audience have no id for this unit.
                        bids: [
                            { bidder: 'adform', params: {mid: '1877538', priceType: 'net'} },
                            publicisBid('2307133', '2307142'), // Publicis Adform SSP: desktop mid, mobile mid.
                            { bidder: "eskimi", params: {placementId: 1583}},
                            { bidder: 'ix', params: {siteId: '1081939'} },
                            { bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682247'} },
                            { bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802522'} },
                            { bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            { bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279078} },
                            { bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '120628'} },
                            { bidder: 'teads', params: {pageId: 204248, placementId: 220494} },
                        ]
                    }
                );

            }   

            // **************** InText_3 GPT and Prebid definition. *******************

            else if (el.id === 'InText_3') { // Check if InText_3 div is present in body. 

                // InText_3 ad unit definition
                InText_3 = googletag.defineSlot(adUnitPath + 'InText_3', [[300, 250]], 'InText_3')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_3')
                                     .setTargeting('refresh_count', '0')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_3 Prebid placement IDs to the BTF array (lazy loaded, like the template's lazyAd div).      
                adUnitsBTF.push(
                    {   code: 'InText_3',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        // Bidders = the live (not deleted) columns of the Bizportal.rs tab in the Alo HB sheet.
                        // Criteo, SMN, Xandr and Yandex are marked deleted there; Direct Media and Rich Audience have no id for this unit.
                        bids: [
                            { bidder: 'adform', params: {mid: '1877539', priceType: 'net'} },
                            { bidder: "eskimi", params: {placementId: 1583}},
                            { bidder: 'ix', params: {siteId: '1081940'} },
                            { bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682248'} },
                            { bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802523'} },
                            { bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            { bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279080} },
                            { bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '120629'} },
                            { bidder: 'teads', params: {pageId: 204248, placementId: 220494} },
                        ]
                    }
                );

            }   

            // **************** InText_4 GPT and Prebid definition. *******************

            else if (el.id === 'InText_4') { // Check if InText_4 div is present in body. 

                // InText_4 ad unit definition
                InText_4 = googletag.defineSlot(adUnitPath + 'InText_4', [[300, 250]], 'InText_4')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_4')
                                     .setTargeting('refresh_count', '0')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_4 Prebid placement IDs to the BTF array (lazy loaded, like the template's lazyAd div).      
                adUnitsBTF.push(
                    {   code: 'InText_4',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        // Bidders = the live (not deleted) columns of the Bizportal.rs tab in the Alo HB sheet.
                        // Criteo, SMN, Xandr and Yandex are marked deleted there; Direct Media and Rich Audience have no id for this unit.
                        bids: [
                            { bidder: 'adform', params: {mid: '1877540', priceType: 'net'} },
                            { bidder: "eskimi", params: {placementId: 1583}},
                            { bidder: 'ix', params: {siteId: '1081941'} },
                            { bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682249'} },
                            { bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802524'} },
                            { bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            { bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279082} },
                            { bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '124582'} },
                            { bidder: 'teads', params: {pageId: 204248, placementId: 220494} },
                        ]
                    }
                );

            }   

            // **************** InText_5 GPT and Prebid definition. *******************

            else if (el.id === 'InText_5') { // Check if InText_5 div is present in body. 

                // InText_5 ad unit definition
                InText_5 = googletag.defineSlot(adUnitPath + 'InText_5', [[300, 250]], 'InText_5')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_5')
                                     .setTargeting('refresh_count', '0')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_5 Prebid placement IDs to the BTF array (lazy loaded, like the template's lazyAd div).      
                adUnitsBTF.push(
                    {   code: 'InText_5',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        // Bidders = the live (not deleted) columns of the Bizportal.rs tab in the Alo HB sheet.
                        // Criteo, SMN, Xandr and Yandex are marked deleted there; Direct Media and Rich Audience have no id for this unit.
                        bids: [
                            { bidder: 'adform', params: {mid: '1877541', priceType: 'net'} },
                            { bidder: "eskimi", params: {placementId: 1583}},
                            { bidder: 'ix', params: {siteId: '1081942'} },
                            { bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682250'} },
                            { bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802525'} },
                            { bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            { bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279084} },
                            { bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '124583'} },
                            { bidder: 'teads', params: {pageId: 204248, placementId: 220494} },
                        ]
                    }
                );

            }   

            // **************** InText_6 GPT and Prebid definition. *******************

            else if (el.id === 'InText_6') { // Check if InText_6 div is present in body. 

                // InText_6 ad unit definition
                InText_6 = googletag.defineSlot(adUnitPath + 'InText_6', [[300, 250]], 'InText_6')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_6')
                                     .setTargeting('refresh_count', '0')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_6 Prebid placement IDs to the BTF array (lazy loaded, like the template's lazyAd div).      
                adUnitsBTF.push(
                    {   code: 'InText_6',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        // Bidders = the live (not deleted) columns of the Bizportal.rs tab in the Alo HB sheet.
                        // Criteo, SMN, Xandr and Yandex are marked deleted there; Direct Media and Rich Audience have no id for this unit.
                        bids: [
                            { bidder: 'adform', params: {mid: '1877542', priceType: 'net'} },
                            { bidder: "eskimi", params: {placementId: 1583}},
                            { bidder: 'ix', params: {siteId: '1081943'} },
                            { bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682251'} },
                            { bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802526'} },
                            { bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            { bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279086} },
                            { bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '125172'} },
                            { bidder: 'teads', params: {pageId: 204248, placementId: 220494} },
                        ]
                    }
                );

            }   

            // **************** InText_7 GPT and Prebid definition. *******************

            else if (el.id === 'InText_7') { // Check if InText_7 div is present in body. 

                // InText_7 ad unit definition
                InText_7 = googletag.defineSlot(adUnitPath + 'InText_7', [[300, 250]], 'InText_7')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_7')
                                     .setTargeting('refresh_count', '0')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_7 Prebid placement IDs to the BTF array (lazy loaded, like the template's lazyAd div).      
                adUnitsBTF.push(
                    {   code: 'InText_7',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        // Bidders = the live (not deleted) columns of the Bizportal.rs tab in the Alo HB sheet.
                        // Criteo, SMN, Xandr and Yandex are marked deleted there; Direct Media and Rich Audience have no id for this unit.
                        bids: [
                            { bidder: 'adform', params: {mid: '1877543', priceType: 'net'} },
                            { bidder: "eskimi", params: {placementId: 1583}},
                            { bidder: 'ix', params: {siteId: '1081944'} },
                            { bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682252'} },
                            { bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802527'} },
                            { bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            { bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279088} },
                            { bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '125173'} },
                            { bidder: 'teads', params: {pageId: 204248, placementId: 220494} },
                        ]
                    }
                );

            }   

            // **************** InText_8 GPT and Prebid definition. *******************

            else if (el.id === 'InText_8') { // Check if InText_8 div is present in body. 

                // InText_8 ad unit definition
                InText_8 = googletag.defineSlot(adUnitPath + 'InText_8', [[300, 250]], 'InText_8')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_8')
                                     .setTargeting('refresh_count', '0')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_8 Prebid placement IDs to the BTF array (lazy loaded, like the template's lazyAd div).      
                adUnitsBTF.push(
                    {   code: 'InText_8',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        // Bidders = the live (not deleted) columns of the Bizportal.rs tab in the Alo HB sheet.
                        // Criteo, SMN, Xandr and Yandex are marked deleted there; Direct Media and Rich Audience have no id for this unit.
                        bids: [
                            { bidder: 'adform', params: {mid: '1877544', priceType: 'net'} },
                            { bidder: "eskimi", params: {placementId: 1583}},
                            { bidder: 'ix', params: {siteId: '1081945'} },
                            { bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682253'} },
                            { bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802531'} },
                            { bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            { bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279090} },
                            { bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '125174'} },
                            { bidder: 'teads', params: {pageId: 204248, placementId: 220494} },
                        ]
                    }
                );

            }   

            // **************** InText_9 GPT and Prebid definition. *******************

            else if (el.id === 'InText_9') { // Check if InText_9 div is present in body. 

                // InText_9 ad unit definition
                InText_9 = googletag.defineSlot(adUnitPath + 'InText_9', [[300, 250]], 'InText_9')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_9')
                                     .setTargeting('refresh_count', '0')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_9 Prebid placement IDs to the BTF array (lazy loaded, like the template's lazyAd div).      
                adUnitsBTF.push(
                    {   code: 'InText_9',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        // Bidders = the live (not deleted) columns of the Bizportal.rs tab in the Alo HB sheet.
                        // Criteo, SMN, Xandr and Yandex are marked deleted there; Direct Media and Rich Audience have no id for this unit.
                        bids: [
                            { bidder: 'adform', params: {mid: '1877545', priceType: 'net'} },
                            { bidder: "eskimi", params: {placementId: 1583}},
                            { bidder: 'ix', params: {siteId: '1081946'} },
                            { bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682254'} },
                            { bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802601'} },
                            { bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            { bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279092} },
                            { bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '125175'} },
                            { bidder: 'teads', params: {pageId: 204248, placementId: 220494} },
                        ]
                    }
                );

            }   

            // **************** InText_10 GPT and Prebid definition. *******************

            else if (el.id === 'InText_10') { // Check if InText_10 div is present in body. 

                // InText_10 ad unit definition
                InText_10 = googletag.defineSlot(adUnitPath + 'InText_10', [[300, 250]], 'InText_10')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'InText_10')
                                     .setTargeting('refresh_count', '0')
                                     .addService(googletag.pubads());
                
                // Push the defined InText_10 Prebid placement IDs to the BTF array (lazy loaded, like the template's lazyAd div).      
                adUnitsBTF.push(
                    {   code: 'InText_10',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        // Bidders = the live (not deleted) columns of the Bizportal.rs tab in the Alo HB sheet.
                        // Criteo, SMN, Xandr and Yandex are marked deleted there; Direct Media and Rich Audience have no id for this unit.
                        bids: [
                            { bidder: 'adform', params: {mid: '1877546', priceType: 'net'} },
                            { bidder: "eskimi", params: {placementId: 1583}},
                            { bidder: 'ix', params: {siteId: '1081947'} },
                            { bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560682255'} },
                            { bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5802602'} },
                            { bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            { bidder: 'rubicon', params: {accountId: 19712, siteId: 534546, zoneId: 3279094} },
                            { bidder: 'smartadserver', params: {networkId: '4527', siteId: '647389', pageId: '1956164', formatId: '125176'} },
                            { bidder: 'teads', params: {pageId: 204248, placementId: 220494} },
                        ]
                    }
                );

            }   

        }); // End of wrapperAd divs check. 

        //Create sticky ad once the ad is ready to render
        googletag.pubads().addEventListener('slotRenderEnded', function(event) {

            let unitPath = event.slot.getAdUnitPath(); //get the ad unith path for the slot which will render the ad
            let stickyBackground = document.getElementById('adhesion_background'); //get the adhesion background id
            //let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; //check user's screen width

            if (unitPath === adUnitPath + "Sticky" && event.isEmpty === true) {
                let sticky = document.getElementById('Adhesion');
                sticky.style.display = 'none';
            }

            // if ad unit is sticky and the background is not set, set sticky CSS for sticky ad unit
            else if (unitPath === adUnitPath + "Sticky" && stickyBackground === null){
            let sticky = document.getElementById('Adhesion');
            sticky.style.position = 'fixed';
            sticky.style.zIndex = '999999';
            sticky.style.width = '100%';
            sticky.style.height = '';
            sticky.style.bottom = '0px';
            sticky.style.textAlign = 'center';	
            sticky.style.padding = '10px 0px 0px';
            sticky.style.borderTop = '1px #CCC solid';
            
            // create adhesion background
            let background = document.createElement("div");
            background.setAttribute("ID", "adhesion_background");
            background.style.backgroundColor = '#FFF';
            
            if (adWindowWidth > 1024) {
                background.style.opacity = '70%';
            }

            else {
                background.style.opacity = '100%';
            }

            background.style.position = 'absolute';
            background.style.height = '100%';
            background.style.width = '100%';
            background.style.top = '0';
            background.style.left = '0';
            background.style.zIndex = '-1';
            sticky.appendChild(background);

            // create placeholder text
            /*let placeholder = document.createElement("div");
            placeholder.setAttribute("ID", "adText");
            placeholder.style.textAlign = 'center';
            placeholder.style.fontSize = '10px';
            placeholder.style.color = '#CCC';
            placeholder.style.height = '20px';
            placeholder.style.borderTop = '1px #CCC solid';
            placeholder.style.paddingTop = '2px';
            placeholder.textContent = 'Oglas'
            background.appendChild(placeholder);*/
        
            // create close button with svg elements
            let closeButton = document.createElement("div");
            closeButton.setAttribute("ID", "close_adhesion")
            closeButton.style.position = 'absolute';
            closeButton.style.top = '-29px';
            closeButton.style.right = '0px';
            closeButton.style.cursor = 'pointer';
            closeButton.style.padding = '8px';
            //closeButton.style.borderRadius = '50%';
            closeButton.style.border = '1px solid #CCC';
            //closeButton.style.boxShadow = '0 0 3px #b8b9be';
            closeButton.style.background = '#FFF';
            closeButton.style.borderBottom = '1px solid #FFF';
            closeButton.style.borderTopLeftRadius = '10px';
            
            let iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            let iconPath = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'path'
            );

            iconSvg.setAttribute('display', 'block');
            iconSvg.setAttribute('fill', '#000');
            iconSvg.setAttribute('width', '12px');
            iconSvg.setAttribute('height', '12px');
            iconSvg.setAttribute('viewBox', '0 0 8 8');

            iconPath.setAttribute(
                'd',
                'M1.41 0l-1.41 1.41.72.72 1.78 1.81-1.78 1.78-.72.69 1.41 1.44.72-.72 1.81-1.81 1.78 1.81.69.72 1.44-1.44-.72-.69-1.81-1.78 1.81-1.81.72-.72-1.44-1.41-.69.72-1.78 1.78-1.81-1.78-.72-.72z'
            );
            
            iconSvg.appendChild(iconPath);
            closeButton.appendChild(iconSvg); 
            sticky.appendChild(closeButton);
            
            // when user clicks the close button, remove the sticky div
            document.getElementById("close_adhesion").addEventListener('click', function(e) {
                e.preventDefault();
                sticky.parentNode.removeChild(sticky);
            }, false); 


            } 
        });
        
        // Check if adsKeywords object is present
        if (typeof adsKeywords != 'undefined') {

            // Check if adsKeywords attributes are present, if so, pass them as key values to GAM
            if (typeof adsKeywords.category != 'undefined') {
                googletag.pubads().setTargeting('category', adsKeywords.category);
            } 

            if (typeof adsKeywords.subcategory != 'undefined') {
                googletag.pubads().setTargeting('subcategory', adsKeywords.subcategory);
            } 

            if (typeof adsKeywords.pageType != 'undefined') {
                googletag.pubads().setTargeting('pageType', adsKeywords.pageType);
            } 

            if (typeof adsKeywords.articleId != 'undefined') {
                googletag.pubads().setTargeting('articleId', [adsKeywords.articleId].join(','));
            } 
            
            // articleTags: the template writes adsKeywords.tags (an array); articleTags wins if it is ever set.
            var articleTagValues = getArticleTagValues(adsKeywords);
            if (articleTagValues.length > 0) {
                googletag.pubads().setTargeting('articleTags', articleTagValues);
            } 
        }

        let adQueryString = window.location.search; // Get the whole string in the URL. 
        //console.log("Query string is " + adQueryString);

        let adUrlParams = new URLSearchParams(adQueryString); // Get the information after ? in the URL. 
        //console.log("URL param is " +  adUrlParams);

        if (adUrlParams.has('adTest')) { 
            let adValue = adUrlParams.get('adTest'); // If there is a adTest param get the value after =. 
            //console.log("AdTest value is " + adValue);
            googletag.pubads().setTargeting('adTest', adValue); // Send the adTest value to GAM.
        } 

        googletag.pubads().disableInitialLoad(); // Disables requests for ads on page load. 
        googletag.pubads().enableSingleRequest(); // Enables single request mode for fetching multiple ads at the same time.
        googletag.enableServices(); // Enables all GPT services that have been defined for ad slots on the page.

        // Get the list of slots associated with this service.
        googletag.pubads().getSlots().forEach(function(adSlots) {
            googletag.display(adSlots.getSlotElementId()); // Instructs slot services to render all of the defined ad slots. 
        });

        // GAM without Prebid: if prebid.js is not there after PREBID_MISSING_FALLBACK_MS, send the
        // first-screen slots without bids. If it is there, keep waiting for the auction, at most
        // FIRST_SCREEN_HARD_CAP_MS. initAdserver runs only once, so these do nothing after the auction.
        setTimeout(function() {
            if (!isPrebidLoaded()) {
                initAdserver();
            }
        }, PREBID_MISSING_FALLBACK_MS);
        setTimeout(initAdserver, FIRST_SCREEN_HARD_CAP_MS);

    });

    pbjs.que.push(function() {

        pbjs.aliasBidder('adform', 'directmedia', {gvlid:50});
        pbjs.aliasBidder('adform', 'publicis', {gvlid: 50}); // Publicis Adform SSP, own request.
    
        pbjs.setConfig({
    
            priceGranularity: 'high', //$0.01 increments, up to $20

            enableSendAllBids: false, //send only top bids
            targetingControls: {
              alwaysIncludeDeals: true //send all deal bids
            },
    
            //Currency module
            currency: {
                "adServerCurrency": "EUR",
                "conversionRateFile": "https://cdn.jsdelivr.net/gh/prebid/currency-file@1/latest.json",
             },
    
            //Coockie match and user syncs
            userSync: {
                syncEnabled: true,
                syncsPerBidder: 5,
                syncDelay: 3000,
                userIds: [
    
                    { name: "sharedId", 
                      storage: { type: "cookie", name: "_sharedid", expires: 365 } 
                    },
    
                    { name: "id5Id",
                      params: { partner: 1355, externalModuleUrl: 'https://cdn.id5-sync.com/api/1.0/id5PrebidModule.js' },
                      storage: { type: "html5", name: "id5id", expires: 90, refreshInSeconds: 8*3600 }
                    },
    
                    { name: 'teadsId',
                      params: { pubId: 26849 }
                    },
    
                    { name: 'criteo',
                    },
    
                    { name: 'lotamePanoramaId',
                    },
    
                ],
                auctionDelay: 50,
                aliasSyncEnabled: true,
                filterSettings: { all: { bidders: "*", filter: "include" } },
            },

            enableTIDs: true,

            consentManagement: {
                gdpr: {
                  cmpApi: 'iab',
                  timeout: 8000,
                  defaultGdprScope: true
                }
            },

            //useBidCache: true,

            schain: {
                validation: "strict",
                config: {
                  ver:"1.0",
                  complete: 1,
                  nodes: [
                    {
                      asi:"ringier.rs",
                      sid:"20221205191911",
                      hp:1
                    }
                  ]
                }
            }

        });

        pbjs.bidderSettings = {
            standard: {
                storageAllowed: true,
            },
        }; 

        pbjs.setBidderConfig({
            bidders: ['directmedia'],   // can list more bidders here if they share the same config
            config: {
              schain: {
                validation: "relaxed",
                config: {
                  ver:"1.0",
                  complete: 1,
                  nodes: [
                    {
                      asi:"directmedia.biz",
                      sid:"1053",
                      hp:1
                    }
                  ]
                }
              }
            }
          });
        
        
        //Add only ATF ad units.
        pbjs.addAdUnits(adUnitsATF);
        
        //Request bids.
        pbjs.requestBids({
            bidsBackHandler: initAdserver,
            timeout: PREBID_TIMEOUT
        });
    });

    // The first-screen slots, requested together in the first GAM request.
    function getInitialGptSlots() {
        var initialSlots = [];
        var candidates = [Adhesion, Billboard, Branding_Left, Branding_Right, P1, InText_1];
        for (var slotIndex = 0; slotIndex < candidates.length; slotIndex++) {
            if (candidates[slotIndex]) {
                initialSlots.push(candidates[slotIndex]);
            }
        }
        return initialSlots;
    }

    // Send the first-screen slots to GAM, with Prebid's bids when Prebid is there.
    // Called by the auction (bidsBackHandler) or by the fallback timers, whichever comes first.
    function initAdserver() {
        if (pbjs.initAdserverSet) return;
        pbjs.initAdserverSet = true;
        googletag.cmd.push(function() {
            if (isPrebidLoaded()) {
                try {
                    pbjs.setTargetingForGPTAsync();
                } catch (targetingError) {
                    adsDebugLog('prebid targeting failed', targetingError);
                }
            }
            else {
                adsDebugLog('prebid not loaded: first-screen slots sent to GAM without bids');
            }
            googletag.pubads().refresh(getInitialGptSlots());
        });
    };

    // Used by the embedded CMP watchdog after an outage takeover, when GPT dropped
    // the first-screen request while consent was blocked.
    window.__bizportalAdsRecoveryRefresh = function() {
        adsDebugLog('cmp watchdog recovery refresh of the first-screen slots');
        googletag.cmd.push(function() {
            if (isPrebidLoaded()) {
                try {
                    pbjs.setTargetingForGPTAsync();
                } catch (targetingError) {
                    adsDebugLog('prebid targeting failed', targetingError);
                }
            }
            googletag.pubads().refresh(getInitialGptSlots());
        });
    };

    //Add BTF ad units.
    pbjs.que.push(function() {
        pbjs.addAdUnits(adUnitsBTF);
    });

    // Use IntersectionObserver API to check whether an ad slot is at the certain distance. 
    var observer = new IntersectionObserver (function(entries) {

        entries.forEach(entry => {

            if (entry.isIntersecting) {

                let adSlot = entry.target.id; // Get the div id of the slot being observed. 

                // Lazy observer guard: only slots this wrapper loads lazily (Prebid unit in adUnitsBTF).
                // InText_1 also carries lazyAd but is already in the first-screen request.
                if (!isLazyLoadedSlotCode(adSlot)) {
                    observer.unobserve(entry.target);
                    return;
                }

                // The slot goes to GAM once: after its auction; or without bids when Prebid is not
                // there after PREBID_MISSING_FALLBACK_MS; or at the FIRST_SCREEN_HARD_CAP_MS cap.
                let lazySlotRefreshed = false;
                function refreshLazySlotOnce(withBids) {
                    if (lazySlotRefreshed) {
                        return;
                    }
                    lazySlotRefreshed = true;
                    if (withBids) {
                        pbjs.setTargetingForGPTAsync([adSlot]);
                    }
                    refreshLazySlot(adSlot);
                }
                let lazyMissingTimer = setTimeout(function() {
                    if (!isPrebidLoaded()) {
                        adsDebugLog('prebid not loaded: lazy slot sent to GAM without bids', adSlot);
                        refreshLazySlotOnce(false);
                    }
                }, PREBID_MISSING_FALLBACK_MS);
                let lazyHardCapTimer = setTimeout(function() {
                    refreshLazySlotOnce(false);
                }, FIRST_SCREEN_HARD_CAP_MS);

                // Request bids and push the ads to GAM. 
                pbjs.que.push(function() {
                    pbjs.requestBids({
                        timeout: PREBID_TIMEOUT,
                        adUnitCodes: [adSlot],
                        bidsBackHandler: function() {
                            clearTimeout(lazyMissingTimer);
                            clearTimeout(lazyHardCapTimer);
                            refreshLazySlotOnce(true);
                        }
                    });
                });
                observer.unobserve(entry.target); // Stop observing the ad slot which has alredy been seen. 
            }
        })
    }, {rootMargin: DISTANCE_IN_PIXELS_FOR_LAZY_LOADING}); // Distance to the ad slot.

    // True only for a slot whose Prebid ad unit is in adUnitsBTF (loaded lazily by the observer).
    function isLazyLoadedSlotCode(adUnitCode) {
        for (var unitIndex = 0; unitIndex < adUnitsBTF.length; unitIndex++) {
            if (adUnitsBTF[unitIndex].code === adUnitCode) {
                return true;
            }
        }
        return false;
    }

    // Refresh the GAM slot of a lazy div.
    function refreshLazySlot(adSlot) {
        // If div with the certain ID is present and observed, refresh GAM slot.
        if (adSlot === 'P2') {
            googletag.pubads().refresh([P2]); 
        } 

        else if (adSlot === 'P3') {
            googletag.pubads().refresh([P3]); 
        } 
        
        else if (adSlot === 'P4' && adWindowWidth < 1024) {
            googletag.pubads().refresh([P4]); 
        } 

        else if (adSlot === 'P5' && adWindowWidth < 1024) {
            googletag.pubads().refresh([P5]); 
        } 

        else if (adSlot === 'P6' && adWindowWidth < 1024) {
            googletag.pubads().refresh([P6]); 
        } 

        else if (adSlot === 'InText_2') {
            googletag.pubads().refresh([InText_2]); 
        } 

        else if (adSlot === 'InText_3') {
            googletag.pubads().refresh([InText_3]); 
        } 

        else if (adSlot === 'InText_4') {
            googletag.pubads().refresh([InText_4]); 
        } 

        else if (adSlot === 'InText_5') {
            googletag.pubads().refresh([InText_5]); 
        } 

        else if (adSlot === 'InText_6') {
            googletag.pubads().refresh([InText_6]); 
        } 

        else if (adSlot === 'InText_7') {
            googletag.pubads().refresh([InText_7]); 
        } 

        else if (adSlot === 'InText_8') {
            googletag.pubads().refresh([InText_8]); 
        } 

        else if (adSlot === 'InText_9') {
            googletag.pubads().refresh([InText_9]); 
        } 

        else if (adSlot === 'InText_10') {
            googletag.pubads().refresh([InText_10]); 
        } 
    }

    document.querySelectorAll('.lazyAd').forEach(slots => { observer.observe(slots) }); // Check all divs with the class lazyAd and observe them all. 

    
    // Get the list of slots associated with this service for the refresh logic.
    googletag.pubads().getSlots().forEach(function(slotAd) {

        var divId = slotAd.getSlotElementId(); // Get the ID of the ad slot in question.
        let param = slotAd.getTargeting('refresh_count'); // get the ad slot's refresh_count value (it should be 0 at the start)
        let interval;

        // Use IntersectionObserver API to check whether an ad slot is viewable for certain percent. 
        var viewabilityObserver = new IntersectionObserver (function(viewabilityEntries) {

            viewabilityEntries.forEach(viewabilityEntry => {

                let slotId = viewabilityEntry.target.id; // Get the ID of the div ID which is being observed.

                if (viewabilityEntry.isIntersecting) {

                    interval = setInterval(function () {

                        let advertiserID;

                        try {
                            advertiserID = slotAd.getResponseInformation().advertiserId; // Get the order ID of the in view creative.
                          }
                        
                        catch(err) {
                            //console.log("Advertiser ID is not defined for slot " + divId);
                        }

                        if (!GAM_NOREFRESH_ADVERTISER_IDS.includes(advertiserID) && !GAM_NOREFRESH_ADUNITS.includes(divId) && document.visibilityState === "visible") { // If order ID is not included in the GAM_NOREFRESH_ORDER_IDS array and div ID is not included in GAM_NOREFRESH_ADUNITS, do refresh.

                            // GAM without Prebid: refresh the slot without bids.
                            if (!isPrebidLoaded()) {
                                googletag.pubads().refresh([slotAd]);
                                param++;
                                slotAd.setTargeting('refresh_count', param);
                                return;
                            }

                            pbjs.requestBids({ // Request bids from Prebid partners.
                                timeout: PREBID_TIMEOUT,
                                adUnitCodes: [slotId],
                                bidsBackHandler: function() {
                                    pbjs.setTargetingForGPTAsync([slotId]);
                                    googletag.pubads().refresh([slotAd]); // Refresh GAM ad slots.
                                    param++; // Increase the param by 1. 
                                    slotAd.setTargeting('refresh_count', param); // Set the new param as a key value.
                                }
                            });

                        }

                    }, SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000);
                }
 
                else {
                    clearInterval(interval); // If the slot is not intersecting, remove the interval.
                }
            })

        }, {threshold: VISIBILITY_PERCENT_FOR_REFRESH}); // Percent of the ad slot that has to be viewable to start refresh.

            document.querySelectorAll('#' + divId).forEach(viewabilitySlots => { viewabilityObserver.observe(viewabilitySlots) }); // Observe all divs which are present on the page. 
        
    });

}